export default "__VITE_ASSET__a99c2aa4__"